import {CallLogEntry} from '@gt-api';
import {CallCauseUtil} from './call-cause';
import {GtPhoneNumberUtil} from './gt-phone-number.util';
import {CallLogEntryModel} from '@app/models/call-log-entry.model';

export class CallLogStringUtil {
  static getAnsweredByDisplayName(logEntry: Partial<CallLogEntryModel>, prettifiedContactName: string = ''): string {
    let answeredBy = '';
    if (CallCauseUtil.isCallAnswered(logEntry.cause)) {
      if (logEntry.login || logEntry.redirectEntries?.length > 0) {
        answeredBy = prettifiedContactName;
      } else {
        answeredBy = logEntry.cidName === 'unknown' ? '' : logEntry.cidName;
      }
    }
    return answeredBy;
  }

  static getCallerDisplayName(logEntry: CallLogEntry): string {
    return CallLogStringUtil.getPrettifyName(logEntry.firstName, logEntry.lastName);
  }

  static getCallerDisplayNameAndNumber(fullName: string, fullNumber: string): string {
    let displayNameOrNumber: string;
    if (fullNumber !== 'anonymous') {
      displayNameOrNumber = CallLogStringUtil.getDisplayNumber(fullName, fullNumber);
    } else {
      displayNameOrNumber = 'global.anonymous';
    }
    return displayNameOrNumber;
  }

  static getDisplayNumber(name: string, fullNumber: string) {
    const displayNumber = GtPhoneNumberUtil.toDisplay(fullNumber);
    if (name && name.length > 0) {
      return `${name} (${displayNumber})`;
    }
    return displayNumber;
  }

  static getPrettifyName(firstName: string, lastName: string): string {
    let name: string;

    if (!firstName || !firstName.length || firstName === 'undefined') {
      name = lastName;
    } else if (!lastName || !lastName.length || lastName === 'undefined') {
      name = firstName;
    } else if (lastName.indexOf(firstName) === 0) {
      name = lastName;
    } else {
      name = `${firstName} ${lastName}`;
    }

    return name ? name.trim() : name;
  }
}
